var English = "英语";
var French = "法语";
var German = "德语";
var Italian = "意大利语";
var Japanese = "日语";
var Korean = "朝鲜语";
var Portuguese = "葡萄牙语";
var Russian = "俄语";
var Spanish = "西班牙语";
var Bahasa = "印尼语";
var Thai = "泰语";
var Vietnamese = "越南语";
var Turkish = "土耳其语";
var Arabic = "阿拉伯语";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "简体中文",
	"Chinese-Traditional": "繁体中文",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
